import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  crumbs: string[] = [];
  private sub!: Subscription;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.buildCrumbs(this.router.url);

    this.sub = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) => this.buildCrumbs(e.urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private buildCrumbs(url: string): void {
    const segments = url
      .split('?')[0]
      .split('/')
      .filter((s) => s && s !== '');

    this.crumbs = segments.map((s) =>
      s
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    );
  }

  /** Builds a routerLink for a non-terminal crumb at index i */
  getCrumbLink(index: number): string {
    const url = this.router.url.split('?')[0];
    const parts = url.split('/').filter((s) => s);
    return '/' + parts.slice(0, index + 1).join('/');
  }
}
